// Use axios for Symfony routes (/quickpay/*, /rest/*) and ApiClient for Sellsy API V2 routes.
import axios from 'axios';

const saveConditionAcceptation = (payload = {}) => {
    return axios.post('/quickpay/save_condition_acceptation', payload);
};

const checkPdfGenerated = (hash) => {
    return axios.post('/quickpay/pdf', { hash });
};

const fetchPaymentProviders = () => {
    return ApiClient.get('/settings/payments/providers');
};

const enablePlugin = (pluginName) => {
    return ApiClient.post(`/account/plugins/${pluginName}`, {});
};

const fetchPaymentPreferences = () => {
    return axios.get('/rest/documents/payment-preferences');
};

const savePaymentPreferences = (payload) => {
    return axios.put('/rest/documents/payment-preferences', payload);
};

export {
    saveConditionAcceptation,
    checkPdfGenerated,
    fetchPaymentProviders,
    enablePlugin,
    fetchPaymentPreferences,
    savePaymentPreferences,
};
